import type { ResourceConfigEntry } from './types';

/** 合并资源条目 watchFields */
export function resolveWatchFieldsFromResourceConfigs(configs: ResourceConfigEntry[]): string[] {
  const fields = new Set<string>();
  configs.forEach((config) => config.watchFields?.forEach((field) => fields.add(field)));
  return Array.from(fields);
}

/** 资源 watchFields 集合（用于判断变更是否触发计价） */
export function resolveResourceWatchFieldSet(configs: ResourceConfigEntry[]): Set<string> {
  return new Set(resolveWatchFieldsFromResourceConfigs(configs));
}

/** 变更字段中是否包含资源 watchFields */
export function hasResourceWatchFieldChange(changedFields: string[], configs: ResourceConfigEntry[]): boolean {
  const resourceFields = resolveResourceWatchFieldSet(configs);
  return changedFields.some((field) => resourceFields.has(field));
}

/** 合并资源 watchFields 与额外监听字段（去重） */
export function resolveCombinedWatchFields(configs: ResourceConfigEntry[], extraWatchFields?: string[]): string[] {
  return Array.from(new Set([...resolveWatchFieldsFromResourceConfigs(configs), ...(extraWatchFields ?? [])]));
}

/** 是否为由资源配置自动维护的展示行 */
export function isAutoManagedDisplayRow(id: string, configs: ResourceConfigEntry[]): boolean {
  return configs.some((config) => {
    if (config.displayIds?.some((displayId) => id === displayId || id.startsWith(`${displayId}-`))) return true;
    if (config.displayIdPrefix && id.startsWith(config.displayIdPrefix)) return true;
    return false;
  });
}

/** 参与计价的资源 code */
export function resolvePricingResourceCodes(configs: ResourceConfigEntry[]): Set<string> {
  return new Set(configs.filter((item) => item.pricing !== false).map((item) => item.code));
}
